export default __webpack_public_path__ + "static/media/man.3bf9d5cf.png";